/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Form Data
 */

export const FORM = {
    placeholders:{
        name: 'Nome',
        email: 'Email',
        subject: 'Assunto',
        message: 'Mensagem',
        rgpd: 'Declaro que aceito que a Beecaramulo envie a informação ora solicitada em resposta a esta minha mensagem, consentindo expressamente na utilização e no tratamento dos meus dados pessoais acima fornecidos para tal efeito.'
    },
    placeholdersError: {
        name: 'Por favor, insira o seu nome.',
        email: 'Por favor, insira o seu email.',
        subject: 'Por favor, insira o assunto.',
        message: 'Por favor, insira a sua mensagem.',
        rgpd: 'Deverá concordar com o exposto antes de avançar.'
    },
    messages: {
        errorHeading: 'Oh! Algo aconteceu!',
        error: 'O envio falhou. Por favor tente novamente ou entre em contacto telefónico connosco.',
        success: 'Mensagem enviada. Obrigado!',
        successBtnClose: 'Fechar'
    },
    submitButton:{
        holding: 'Enviar',
        sending: 'A enviar...'
    }
}